/*eslint id-length: 0 */
import _ from '../i18n.jsx';
const cancerList = [
    { name: _('Bladder cancer'), value: 'Invitae73' },
    { name: _('Bone or soft tissue cancer (sarcoma)'), value: 'Invitae527' },
    { name: _('Breast cancer'), value: 'Invitae80' },
    { name: _('Brain cancer'), value: _('Brain cancer') },
    { name: _('Cervical cancer'), value: 'Invitae97' },
    { name: _('Colon or rectal cancer'), value: 'Invitae121' },
    { name: _('Endometrial or uterine cancer'), value: 'Invitae176' },
    { name: _('Esophageal cancer'), value: 'Invitae180' },
    { name: _('Germ cell cancer'), value: 'Invitae208' },
    { name: _('Head and neck cancer'), value: 'Invitae234' },
    { name: _('Gastric cancer'), value: _('Gastric cancer') },
    { name: _('Kidney cancer'), value: _('Kidney cancer') },
    { name: _('Leukemia or lymphoma'), value: 'Invitae312' },
    { name: _('Liver cancer'), value: 'Invitae322' },
    { name: _('Lung cancer'), value: 'Invitae327' },
    { name: _('Ovarian cancer'), value: 'Invitae435' },
    { name: _('Pancreatic cancer'), value: 'Invitae438' },
    { name: _('Prostate cancer'), value: 'Invitae468' },
    { name: _('Skin cancer (melanoma)'), value: 'Invitae344' },
    { name: _('Stomach or gastric cancer'), value: 'Invitae539' },
    { name: _('Testicular cancer'), value: 'Invitae547' },
    { name: _('Throat cancer'), value: 'Invitae550' },
    { name: _('Thyroid cancer'), value: 'Invitae553' },
    { name: _('Urinary tract cancer'), value: 'Invitae574' }
];
export default cancerList;
